import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { requestScopes } from 'src/authConfig';

import HomePage from './home/page'
import Login from 'src/components/files/onedrive/login';
import { useMS } from 'src/components/files/onedrive/context/MSContext';

const Cloud = () => {
  const { instance, accounts } = useMsal();
  const { setaccessToken, setaccount } = useMS()

  async function RequestProfileData() {
    const response = await instance.acquireTokenSilent({...requestScopes, account: accounts[0]})
    setaccount(response.account)
    setaccessToken(response.accessToken)
  }
  useEffect(()=>{
    if(accounts[0]) { RequestProfileData() }
  }, [accounts])

  return (
    <>
    <UnauthenticatedTemplate>
      <Login />
    </UnauthenticatedTemplate>
    <AuthenticatedTemplate>
      <Routes>
        <Route path="*" element={<HomePage />} />
      </Routes>
    </AuthenticatedTemplate>
    </>
  )
}

export default Cloud